
<template>
  <div>
    <base-header class="pb-6 pb-8 pt-8 pt-md-5">
      <!-- Card stats -->
    </base-header>

    <div class="container-fluid mt--7">
      <div class="row">
        <div class="col">
          <div class="col-xl-8 order-xl-1">
            <card shadow>
              <template #header>
                <div class="border-0">
                  <div class="row align-items-center">
                    <div class="col-8 text-start">
                      <h5 v-if="!isUpdate" class="mb-0">{{ $t("New healthcare request") }}</h5>
                      <h5 v-else class="mb-0">Update Request</h5>
                    </div>
                  </div>
                </div>
              </template>
              <form>
                <div class="progress mb-4">
                  <div
                      class="progress-bar progress-bar-striped progress-bar-animated bg-primary"
                      role="progressbar"
                      :style="{ width: ((currentStep / questionsLength) * 100) + '%' }"
                      :aria-valuenow="currentStep"
                      :aria-valuemin="1"
                      :aria-valuemax="questionsLength"
                  ></div>
                </div>
                <!--                <div class="text-start fw-bolder text-uppercase text-muted">Personal Details </div>-->
                <!--                <hr class="mt-0">-->
                <div class="text-start fw-bolder text-uppercase text-muted">{{ normalizeGreek($t("Request Details")) }}</div>
                <hr class="mt-0">
                <div class="ps-lg-4">
                  <div class="row">
                    <div class="col-lg-12 text-start">
                      <label class="form-label fw-bold">{{ $t("Select healthcare professional") }}</label>
                      <div class="form-group has-label" :class="{'has-danger': v$.model.employeeType.$error }">
                        <div v-for="type in employeeTypes" :key="type" class="form-check-inline">
                          <input :id="type" v-model="model.employeeType" class="form-check-input" type="radio" :name="type" :value="type" />
                          <label class="form-check-label ps-1" :for="type" :title="type" aria-hidden="true">{{ $t(type) }}</label>
                        </div>
                        <div v-if="v$.model.employeeType.$invalid" class="text-danger invalid-feedback"
                             style="display: block;"
                        >
                          {{
                            v$.model.employeeType.$errors.map(err => {
                              return err.$message
                            })[0]
                          }}
                        </div>
                      </div>
                    </div>
                    <div v-if="model.employeeType && model.employeeType === 'nurse'" class="col-lg-12 text-start">
                      <label class="form-label fw-bold">{{ $t("What kind of support do you need?") }}</label>
                      <div class="form-group has-label" :class="{'has-danger': v$.model.serviceType.$error }">
                        <div v-for="type in serviceTypes" :key="type" class="form-check-inline">
                          <input :id="type" v-model="model.serviceType" class="form-check-input" type="radio" :name="type" :value="type" />
                          <label class="form-check-label ps-1" :for="type" :title="type" aria-hidden="true">{{ $t(type) }}</label>
                        </div>
                        <div v-if="v$.model.serviceType.$invalid" class="text-danger invalid-feedback"
                             style="display: block;"
                        >
                          {{
                            v$.model.serviceType.$errors.map(err => {
                              return err.$message
                            })[0]
                          }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="ps-lg-4">
                  <div class="row">
                    <div v-if="['shift', 'service'].includes(model.serviceType)" class="col-lg-5">
                      <div class="form-group has-label" :class="{'has-danger': v$.model.shiftDate.$error }">
                        <label class="form-label fw-bold">{{
                            $t("When?")
                          }}</label>
                        <VueDatePicker
                            v-model="model.shiftDate"
                            :locale="$store.state.locale"
                            auto-apply
                            format="dd/MM/yyyy"
                            :flow="['calendar']"
                            :min-date="startOfToday"
                            :placeholder="$t('Choose your date')"
                        ></VueDatePicker>
                        <div v-if="v$.model.shiftDate.$invalid" class="text-danger invalid-feedback"
                             style="display: block;"
                        >
                          {{
                            v$.model.shiftDate.$errors.map(err => {
                              return err.$message
                            })[0]
                          }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div v-if="['service'].includes(model.serviceType) && model.shiftDate" class="col-lg-6">
                      <div class="form-group has-label">
                        <label class="form-label fw-bold">{{ $t("Preferred time") }}</label>
                        <div class="row">
                          <div class="col-md-6">
                            <VueDatePicker
                                v-model="model.startTime"
                                :locale="$store.state.locale"
                                :select-text="$t('Select')"
                                :cancel-text="$t('Cancel')"
                                :start-time="{ hours: 10, minutes: 0 }"
                                minutes-increment="10"
                                minutes-grid-increment="10"
                                format="HH:mm"
                                time-picker
                                :flow="['time']"
                                :placeholder="$t('From')"
                            ></VueDatePicker>
                            <div v-if="v$.model.startTime.$invalid" class="text-danger invalid-feedback"
                                 style="display: block;"
                            >
                              {{
                                v$.model.startTime.$errors.map(err => {
                                  return err.$message
                                })[0]
                              }}
                            </div>
                          </div>
                          <div class="col-md-6">
                            <VueDatePicker
                                v-model="model.endTime"
                                :locale="$store.state.locale"
                                :select-text="$t('Select')"
                                :cancel-text="$t('Cancel')"
                                :start-time="{ hours: 10, minutes: 0 }"
                                minutes-increment="10"
                                time-picker
                                minutes-grid-increment="10"
                                format="HH:mm"
                                :flow="['time']"
                                :placeholder="$t('To')"
                            ></VueDatePicker>
                            <div v-if="v$.model.endTime.$invalid" class="text-danger invalid-feedback"
                                 style="display: block;"
                            >
                              {{
                                v$.model.endTime.$errors.map(err => {
                                  return err.$message
                                })[0]
                              }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>


                    <div v-if="model.serviceType === 'service' && model.shiftDate" class="col-lg-12 text-start">
                      <label class="form-label fw-bold">{{ $t("Select the services required:") }}
                        <span v-if="requestCost">{{ '€' + model.cost.totalCost/100 }}</span>
                      </label>
                      <div class="form-group has-label">
                        <div v-for="service in services" :key="'s'+service.id" class="form-check">
                          <input :id="'s'+service.id" v-model="model.services" class="form-check-input" type="checkbox" :name="getTranslation(service.name, $store.state.locale)" :value="service" />
                          <label class="form-check-label ps-1" :for="'s'+service.id" :title="getTranslation(service.name, $store.state.locale)" aria-hidden="true">
                            {{ getTranslation(service.name, $store.state.locale) }}
                          </label>

                          <tooltip :tooltip-text="getTranslation(service.description, $store.state.locale)">
                            <i class="fa fa-info-circle ps-2"></i>
                          </tooltip>
                        </div>
                        <div v-if="model.services.length === 0 && v$.model.$dirty" class="text-danger invalid-feedback"
                             style="display: block;"
                        >
                          {{ $t("You need to select at least one Service") }}
                        </div>
<!--                        <div v-if="v$.model.services.$invalid" class="text-danger invalid-feedback"-->
<!--                             style="display: block;"-->
<!--                        >-->
<!--                          {{-->
<!--                            v$.model.services.$errors.map(err => {-->
<!--                              return err.$message-->
<!--                            })[0]-->
<!--                          }}-->
<!--                        </div>-->
                      </div>
                    </div>

<!--                    <div v-if="model.serviceType === 'service'" class="col-lg-12">-->
<!--                      <div class="form-group has-label" :class="{'has-danger': v$.model.serviceType.$error }">-->
<!--                        <label class="form-label">{{ $t("Select the services required:") }}</label>-->
<!--                        <multiselect-->
<!--                            :show-labels="false"-->
<!--                            :placeholder="$t('Add service')"-->
<!--                            :options="services.filter(s => !model.services.map(m => m.id).includes(s.id))"-->
<!--                            :multiple="false"-->
<!--                            @select="addService"-->
<!--                        >-->
<!--                          <template #singleLabel="{ option }">{{ option.name.en }}</template>-->

<!--                          <template #option="props">-->
<!--                            {{ props.option.name.en }}-->
<!--                          </template>-->
<!--                        </multiselect>-->
<!--                        &lt;!&ndash;                        <div v-if="v$.model.serviceType.$invalid" class="text-danger invalid-feedback" style="display: block;">&ndash;&gt;-->
<!--                        &lt;!&ndash;                          {{ v$.model.serviceType.$errors.map( err => { return err.$message })[0] }}&ndash;&gt;-->
<!--                        &lt;!&ndash;                        </div>&ndash;&gt;-->
<!--                      </div>-->
<!--                    </div>-->
<!--                    <div v-if="model.serviceType === 'service' && model.services.length > 0" class="col-lg-12">-->
<!--                      <table class="table">-->
<!--                        <tr>-->
<!--                          <th class="text-start">No</th>-->
<!--                          <th class="text-start">Name</th>-->
<!--                          <th></th>-->
<!--                        </tr>-->
<!--                        <tr v-for="(item, index) in model.services" :key="index" class="list-unstyled text-start">-->
<!--                          <td>{{ index + 1 }}</td>-->
<!--                          <td>{{ item.name.en }}</td>-->
<!--                          <td>-->
<!--                            <button class="btn btn-outline-danger" @click="removeService(item)">-->
<!--                              <i-->
<!--                                  class="fa fa-times"-->
<!--                              ></i>-->
<!--                            </button>-->
<!--                          </td>-->
<!--                        </tr>-->
<!--                      </table>-->
<!--                    </div>-->
                    <div v-if="model.serviceType === 'shift' && model.shiftDate != null" class="col-lg-12 text-start">
                        <label class="form-label fw-bold">{{ $t("What type of live-in care you want?") }}</label>
                        <div class="form-group has-label" :class="{'has-danger': v$.model.shiftService.$error }">
                          <div v-for="service in services" :key="service.id" class="form-check-inline">
                            <input :id="service.id" v-model="model.shiftService" class="form-check-input" type="radio" :name="getTranslation(service.name, $store.state.locale)" :value="service" />
                            <label class="form-check-label ps-1" :for="service.id" :title="getTranslation(service.name, $store.state.locale)" aria-hidden="true">
                              {{ getTranslation(service.name, $store.state.locale) }}
                              <tooltip :tooltip-text="getTranslation(service.description, $store.state.locale)">
                                <i class="fa fa-info-circle ps-2"></i>
                              </tooltip>
                            </label>
                          </div>
                          <div v-if="v$.model.shiftService.$invalid" class="text-danger invalid-feedback"
                               style="display: block;"
                          >
                            {{
                              v$.model.shiftService.$errors.map(err => {
                                return err.$message
                              })[0]
                            }}
                          </div>
                        </div>
                    </div>
                    <div
                        v-if="model.serviceType === 'shift' && model.shiftService != null && model.shiftDate != null && model.shiftService.timeSlots.length > 0"
                        class="col-lg-12"
                    >
                      <div class="form-group has-label" :class="{'has-danger': v$.model.shiftSlot.$error }">
                        <label class="form-label fw-bold">{{ $t("Please select your preferred live-in care time:") }}</label>
                        <multiselect
                            v-model="model.shiftSlot"
                            :show-labels="false"
                            :placeholder="$t('Select time slot')"
                            :options="model.shiftService.timeSlots" :multiple="false"
                        >
                          <template #singleLabel="{ option }">
                            {{ option.startTime }} - {{ option.endTime }} ({{ option.priceInCents / 100 + '€' }})
                          </template>
                          <template #option="props">
                            {{ props.option.startTime }} - {{ props.option.endTime }}
                            ({{ props.option.priceInCents / 100 + '€' }})
                          </template>
                        </multiselect>
                        <!--                        <div v-if="v$.model.serviceType.$invalid" class="text-danger invalid-feedback" style="display: block;">-->
                        <!--                          {{ v$.model.serviceType.$errors.map( err => { return err.$message })[0] }}-->
                        <!--                        </div>-->
                      </div>
                    </div>
                    <!--                    <div v-if="model.startDate > new Date()" class="col-md-12">-->
                    <!--                      <div class="text-start pt-0 pb-4 text-black-50">-->
                    <!--                        <label><b>* {{ $t("Claim deadline") }}</b> {{ $t("is the latest time by which a request can be claimed.") }}</label>-->
                    <!--                      </div>-->
                    <!--                    </div>-->
                    <!--                  <div v-if="model.startDate < new Date() && userRole === 'system'" class="col-md-12">-->
                    <!--                    <div class="form-group has-label" :class="{'has-danger': v$.model.buyerId.$error }">-->
                    <!--                      <label class="form-label">{{ $t("Partner to assign shift") }}</label>-->
                    <!--                      <multiselect-->
                    <!--                          v-model="model.buyerId"-->
                    <!--                          :show-labels="false"-->
                    <!--                          label="name"-->
                    <!--                          track-by="id"-->
                    <!--                          :placeholder="$t('Select Partner')"-->
                    <!--                          :options="employees" :multiple="false"-->
                    <!--                      ></multiselect>-->
                    <!--                      <div v-if="v$.model.buyerId.$invalid" class="text-danger invalid-feedback" style="display: block;">-->
                    <!--                        {{ v$.model.buyerId.$errors.map( err => { return err.$message })[0] }}-->
                    <!--                      </div>-->
                    <!--                    </div>-->
                    <!--                  </div>-->
                    <div v-if="(model.serviceType === 'shift' && model.serviceType !== null && model.shiftSlot) || model.services.length > 0" class="col-lg-12 text-start">
                      <label class="form-label fw-bold">{{ $t("How do you intend to pay the professional?") }}</label>
                      <div class="form-group has-label" :class="{'has-danger': v$.model.preferredPaymentMethod.$error }">
                        <div v-for="method in ['cash', 'card', 'bank_transfer']" :key="method" class="form-check-inline">
                          <input :id="method" v-model="model.preferredPaymentMethod" class="form-check-input" type="radio" :name="method" :value="method" />
                          <label class="form-check-label ps-1" :for="method" :title="method" aria-hidden="true">{{ $t(method) }}</label>
                        </div>
                        <div v-if="v$.model.preferredPaymentMethod.$invalid" class="text-danger invalid-feedback"
                             style="display: block;"
                        >
                          {{
                            v$.model.preferredPaymentMethod.$errors.map(err => {
                              return err.$message
                            })[0]
                          }}
                        </div>
                      </div>
                    </div>
                    <div v-if="(model.serviceType === 'shift' && model.serviceType !== null && model.shiftSlot) || model.services.length > 0" class="col-md-12">
                      <div class="form-group has-label" :class="{'has-danger': v$.model.gender.$error }">
                        <label class="form-label fw-bold">{{ $t("What gender do you prefer?") }} </label>
                        <multiselect
                            v-model="model.gender"
                            :show-labels="false"
                            :placeholder="$t('Select gender')"
                            :options="['noPref', 'male', 'female']"
                            :allow-empty="false"
                        >
                          <template #singleLabel="{ option }">{{ $t(option ?? '') }}</template>
                          <template #option="props">
                            {{ $t(props.option ?? '') }}
                          </template>
                        </multiselect>
                        <div v-if="v$.model.gender.$invalid" class="text-danger invalid-feedback" style="display: block;">
                          {{ v$.model.gender.$errors.map( err => { return err.$message })[0] }}
                        </div>
                      </div>
                    </div>
                    <div v-if="model.preferredPaymentMethod" class="col-lg-12">
                      <div class="form-group has-label">
                        <label class="form-label fw-bold">{{ $t("Describe the situation") }}</label>
                        <base-input>
                            <textarea
                                v-model="model.notes"
                                rows="4"
                                class="form-control form-control-alternative"
                                placeholder=""
                            >
                            </textarea>
                          <template #infoBlock>
                            <span class="w-100 text-sm text-muted">
                              {{ $t("What is the current health condition? Who needs help and why? Please include any relevant medical or personal context.") }}
                            </span>
                            <div class="w-100 text-sm text-muted">
                              {{ $t("Help us understand the context so we can match you with the right professional.") }}
                            </div>
                          </template>
                          <div v-if="v$.model.notes.$invalid" class="text-danger invalid-feedback" style="display: block;">
                            {{ v$.model.notes.$errors.map( err => { return err.$message })[0] }}
                          </div>
                        </base-input>
                      </div>
                    </div>
                  </div>
                </div>
                <template v-if="model.preferredPaymentMethod">
                  <div class="text-start fw-bolder text-uppercase text-muted">
                    {{ normalizeGreek(userRole === 'system' ? $t("Client Details") : $t("Address at which the services should be provided")) }}
                  </div>
                  <hr class="mt-0">
                  <div class="ps-lg-4">
                    <div class="row">
                      <div class="col-md-12">
                        <base-input
                            v-model="model.address.street"
                            alternative=""
                            label="Address (Street & Number, Building Name, Floor, Flat No.)"
                            placeholder="Street & Number, Building Name, Floor, Flat No."
                            input-classes="form-control-alternative"
                            :error="v$.model.address.street.$errors.map( err => { return err.$message })[0]"
                        />
                      </div>
                      <div class="col-lg-4">
                        <div class="form-group has-label" :class="{'has-danger': v$.model.address.city.$error }">
                          <label class="form-control-label">{{ $t('City') }}</label>

                          <multiselect
                              v-model="model.address.city"
                              :show-labels="false"
                              deselect-label="Can't remove this value"
                              placeholder="Select city"
                              :options="cities"
                              :searchable="false"
                              :custom-label="customCityLabel"
                          >
                          </multiselect>

                          <div v-if="v$.model.address.city.$error" class="text-danger invalid-feedback" style="display: block;">
                            {{ v$.model.address.city.$errors.map( err => { return err.$message })[0] }}
                          </div>
                        </div>
                      </div>
                      <div class="col-lg-4">
                        <base-input
                            v-model="model.address.postCode"
                            alternative=""
                            label="Post code"
                            placeholder="Post code"
                            input-classes="form-control-alternative"
                            :error="v$.model.address.postCode.$errors.map( err => { return err.$message })[0]"
                        />
                      </div>
                      <div class="col-lg-4">
                        <div class="form-group has-label">
                          <label class="form-control-label">{{ $t("Country") }} <!--v-if--></label>
                          <!--v-if--><input alternative="" class="form-control form-control-alternative" :placeholder="$t('Country')" disabled="" aria-describedby="addon-right addon-left" :value="$t('Cyprus')"><!--v-if--><!--v-if-->
</div>
                      </div>
                    </div>
                  </div>
                </template>
                <div v-if="showCost" class="text-start fw-bolder text-uppercase text-muted">{{ $t("Request Cost") }}</div>
                <hr class="mt-0">
                <div v-if="showCost" class="ps-lg-4">
                  <div class="row">
                    <label v-if="!showCost" class="text-start float-start">{{
                        $t("Cost cannot be calculated yet.") }}
                    </label>
                    <label v-if="userRole === 'client' && showCost" class="text-start float-start fw-bold">
                      {{ $t("The total cost is to be paid directly to the professional attending to your service.") }}
                    </label>
                    <div v-if="showCost" class="col-md-4 pt-2">
                      <display-label
                          label="Total cost:"
                          :value="model.cost.totalCost == null ? '€' : '€' + model.cost.totalCost/100"
                      ></display-label>
                    </div>
                    <div v-if="userRole !== 'client'" class="col-md-4 pt-2">
                      <display-label
                          label="Employee earnings:"
                          :value="model.cost.employeeEarnings == null ? '€' : '€'+ model.cost.employeeEarnings/100"
                      ></display-label>
                    </div>
                    <div v-if="userRole !== 'client'" class="col-md-4 pt-2">
                      <display-label
                          label="Company commission:"
                          :value="model.cost.companyCommission == null ? '€' : '€'+model.cost.companyCommission/100"
                      ></display-label>
                    </div>
                  </div>
                </div>
                <!--                <div class="text-start fw-bolder text-uppercase text-muted">Documents </div>-->
                <!--                <hr class="mt-0">-->
                <!--                <div class="ps-lg-4">-->
                <!--                  <div class="row"></div>-->
                <!--                </div>-->

                <div class="col-12 text-end">
                  <div v-if="showCost" class="text-end pb-3" :class="[{ 'has-danger': v$.model.termsAndConditions.$error }]">
                    <input v-model="model.termsAndConditions" class="form-check-input p-2 float-end" type="checkbox" value="false">
                    {{ $t("I agree to the") }}
                    <a class="text-decoration-underline pe-2" target="_blank" :href="`/terms-and-conditions${$store.state.locale === 'el' ? '-gr' : ''}.html`">
                      {{ $t("terms & conditions") }}
                    </a>
                    <div v-if="v$.model.termsAndConditions.$invalid" class="text-danger invalid-feedback"
                         style="display: block;"
                    >
                      {{ v$.model.termsAndConditions.$errors.map(err => {return err.$message})[0] }}
                    </div>
                  </div>
                  <div v-if="showCost" class="alert alert-warning" role="alert">
                    {{
                      $t("Any consumables will not be provided by the healthcare professional. This can be arranged after consultation with the professional.")
                    }}
                  </div>
<!--                  <base-button v-if="!isUpdate" class="me-2" outline type="info" @click="clearForm">-->
<!--                    {{-->
<!--                      $t("Reset")-->
<!--                    }}-->
<!--                  </base-button>-->
                  <submit-button :alert-message="errorMessage" loading-text="" :state="loadingProcess" @clicked="submit">
                    {{ $t(isUpdate ? 'Update' : 'Submit') }}
                  </submit-button>
                </div>
              </form>
            </card>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BaseInput from "@/components/BaseInput.vue"
import DisplayLabel from "@/components/DisplayLabel.vue"
import useVuelidate from "@vuelidate/core"
import {helpers, maxLength, minLength, required, requiredIf, sameAs} from "@vuelidate/validators"
import {calculateRequestCost} from "@/helpers/shiftCostCalculator"
import FirebaseFunctionsHelper from "@/helpers/firebaseFunctionsHelper"
import Card from "@/components/Card.vue"
import BaseButton from "@/components/BaseButton.vue"
import SubmitButton from "@/components/SubmitButton.vue"
import {getTranslation, normalizeGreek} from "@/helpers/common"
import Tooltip from "@/components/Tooltip.vue"

export default {
  name: "RequestFormStepper",
  components: {Tooltip, SubmitButton, Card, BaseInput, DisplayLabel},
  setup: () => ({v$: useVuelidate()}),
  data() {
    return {
      servicesFromCache: [],
      isHydratingFromCache: false,
      cities: ["LIMASSOL", "NICOSIA", "LARNACA", "PAPHOS", "AMOCHOSTOS"],
      clientConfigs: null,
      refreshKey: 1,
      clients: [],
      country: "Cyprus",
      services: [],
      employees: [],
      isUpdate: false,
      errorMessage: "",
      loadingProcess: "",
      loadingMessage: "",
      model: {
        // requestStatus: {id: "PENDING", name: this.$t("Pending")},
        clientId: null,
        preferredPaymentMethod: null,
        serviceType: null,
        buyerId: null,
        shiftDate: null,
        notes: null,
        endTime: null,
        employeeType: null,
        startTime: null,
        // shiftService: {name: {en:"",gr:""}, timeSlots: []},
        shiftService: null,
        shiftSlot: null,
        gender: "noPref",
        services: [],
        address: {
          street: "",
          city: "",
          postCode: "",
          locality: "",
          countryCode: "CY",
        },
        cost: {
          totalCost: null,
          employeeEarnings: null,
          companyCommission: null,
        },
        termsAndConditions: false
      }

    }
  },
  validations() {
    return {
      model: {
        address: {
          street: {
            required: helpers.withMessage(this.$t("Value is required"), required)
          },
          city: {
            required: helpers.withMessage(this.$t("Value is required"), required)
          },
          postCode: {
            required: helpers.withMessage(this.$t("Value is required"), required),
            minLength: minLength(4),
            maxLength: maxLength(4),
          },
        },
        clientId: {
          required: helpers.withMessage(this.$t("Value is required"), required)
        },
        gender: {
          required: helpers.withMessage(this.$t("Value is required"), required)
        },
        preferredPaymentMethod: {
          required: helpers.withMessage(this.$t("Value is required"), required)
        },
        // deadline: {
        //   required: helpers.withMessage(this.$t("Value is required"), required),
        //   maxValue: helpers.withMessage(this.$t("Deadline must be before start date."), maxValue(this.model.shiftDate))
        // },
        termsAndConditions: {
          sameAsRawValue: helpers.withMessage(this.$t("Please accept terms & conditions"), sameAs(true))
        },
        shiftDate: {
          required: helpers.withMessage(this.$t("Value is required"), required)
        },
        shiftSlot: {
          requiredIf: helpers.withMessage(this.$t("Value is required"), requiredIf(this.model.serviceType === "shift"))
        },
        startTime: {
          requiredIf: helpers.withMessage(this.$t("Value is required"), requiredIf(this.model.serviceType === "service")),
        },
        endTime: {
          requiredIf: helpers.withMessage(this.$t("Value is required"), requiredIf(this.model.serviceType === "service")),
        },
        shiftService: {
          requiredIf: helpers.withMessage(this.$t("Value is required"), requiredIf(this.model.serviceType === "shift"))
        },
        serviceType: {
          required: helpers.withMessage(this.$t("Value is required"), required)
        },
        employeeType: {
          required: helpers.withMessage(this.$t("Value is required"), required)
        },
        notes: {
          required: helpers.withMessage(this.$t("Value is required"), required)
        },
        buyerId: {
          requiredIf: helpers.withMessage(this.$t("Value is required"), requiredIf(() => this.isBeforeToday(this.model.shiftDate)))
        }
      },
    }
  },
  computed: {
    startOfToday() {
      return this.$moment().startOf("day").toDate()
    },
    questionsLength(){
      if (this.model.serviceType === "shift") {
        return 7
      }
      return 6
    },
    currentStep() {
      let step = 0
      if (this.model.employeeType !== null) {
        step++
      }
      if (this.model.serviceType !== null) {
        step++
      }
      if (this.model.shiftDate !== null) {
        step++
      }
      if (this.model.shiftSlot !== null) {
        step++
      }
      if (this.model.services.length > 0 && this.model.serviceType === "service") {
        step++
      }
      if (this.model.address.street !== "") {
        step++
      }
      if (this.model.shiftService !== null) {
        step++
      }
      if (this.model.preferredPaymentMethod !== null) {
        step++
      }
      return step
    },
    serviceTypes() {
      return ["service", "shift"].filter(option => {
        if (this.model.employeeType === "doctor") {
          return option === "service"
        } else if (this.model.employeeType === "physiotherapist") {
          return option === "service"
        } else if (this.model.serviceType === "nurse") {
          return true // Keep both options
        } else {
          return true
        }
      })
    },
    employeeTypes() {
      return ["nurse", "doctor", "physiotherapist"].filter(option => {
        if (this.model.serviceType === "shift") {
          return option === "nurse"
        } else if (this.model.serviceType === "service") {
          return true // Keep both options
        } else {
          return true
        }
      })
    },
    userRole() {
      return this.$store.state.user?.claims?.role ?? null
    },
    showCost(){
      if (this.model.serviceType == null ||
          this.model.serviceType === "shift" && this.currentStep !== 7 ||
          this.model.serviceType === "service" && this.currentStep !== 6) { return false }

      // this.v$.$touch()
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.model.cost = calculateRequestCost(this.clientConfigs, this.model.serviceType === "shift" ? [{timeSlot: this.model.shiftSlot}] : this.model.services ?? [], this.model.serviceType, this.model.employeeType)

      return true
      if (this.v$.model.$invalid) {
        console.log(this.v$.$errors)
        return false
      } else {
        return true
      }
    },
    requestCost() {


      if (this.model.serviceType == null || this.model.employeeType == null || this.model.serviceType === "shift" ? this.model.shiftSlot == null : false){
        return false
      }

      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.model.cost = calculateRequestCost(this.clientConfigs, this.model.serviceType === "shift" ? [{timeSlot: this.model.shiftSlot}] : this.model.services ?? [], this.model.serviceType, this.model.employeeType)
      console.log("this.model.cost", this.model.cost)
      return true
    }
  },
  watch: {
    "model.serviceType": function (newValue) {
      if (this.isHydratingFromCache) {
        return
      }
      console.log("model.serviceType", newValue)
      if (newValue == null) {
        return
      }

      this.model.shiftSlot = null
      this.getServices(newValue, this.model.employeeType)
    },
    "model.employeeType": function (newValue) {
      if (this.isHydratingFromCache) {
        return
      }
      if (newValue == null) {
        return
      }
      if (newValue === "doctor") {
        this.model.serviceType = "service"
      }
      this.getServices(this.model.serviceType, newValue)
    },
    "model.shiftDate": function (newValue) {
      console.log("model.shiftDate newValue", newValue)

      if (newValue !== null && this.isBeforeToday(newValue)) {
        this.getEmployees()
      }

      if (this.model.endDate == null) {
        this.model.endDate = this.$moment(newValue).add("8", "hours").toDate()
      }
    },
    "model.clientId": async function (client) {
      console.log("model.clientId", client)
      if (client) {
        await this.getSettings(client.id)
      }
    },
  },
  async mounted() {
    console.log("this.$store.state.user.claims", this.$store.state.user.claims)
    if (this.userRole === "system") {
      await this.getClients()
    } else {
      console.log("getSettings getSettings getSettings")
      this.model.clientId = { id: this.$store.state.user.claims.user_id}
      await this.getSettings(this.$store.state.user.claims.user_id)
    }
    if (this.$route.params.hasOwnProperty("id")) {
      this.isUpdate = true
      await this.getRequest()
    }

    const cachedModel = localStorage.getItem("pendingRequestModel")
    console.log("cachedModel", cachedModel)
    if (cachedModel) {
      this.$swal.fire({
        title: "Would you like to continue your request?",
        text: "We found an unfinished form. Do you want to pick up where you left off, or start a new request?",
        icon: "success",
        showCancelButton: true,
        confirmButtonText: this.$t("Yes, continue"),
        confirmButtonColor: "green",
        cancelButtonText: this.$t("Start new"),
        cancelButtonColor: "#dc3545",
        reverseButtons: true
      }).then(async (result) => {
        if (result.isConfirmed) {
          const cachedModelFormatted = JSON.parse(cachedModel)
          console.log("cachedModel cachedModelFormatted", cachedModelFormatted)
          const cachedServices = Array.isArray(cachedModelFormatted.services) ? [...cachedModelFormatted.services] : []
          this.servicesFromCache = cachedServices
          console.log("cachedModel servicesFromCache", this.servicesFromCache)
          cachedModelFormatted.services = []
          this.isHydratingFromCache = true
          this.model = { ...this.model, ...cachedModelFormatted }
          try {
            if (this.model.serviceType && this.model.employeeType) {
              await this.getServices(this.model.serviceType, this.model.employeeType)
            }
          } finally {
            this.isHydratingFromCache = false
          }
        }
      })

      localStorage.removeItem("pendingRequestModel") // Clean-up
    }

  },
  methods: {
    getTranslation,
    normalizeGreek,
    isBeforeToday(date) {
      if (date == null) {
        return false
      }

      return this.$moment(date).startOf("day").isBefore(this.$moment().startOf("day"))
    },
    // removeService(service) {
    //   this.model.services.splice(this.model.services.indexOf(service), 1)
    // },
    customCityLabel(option) {
      return this.$t(option)
    },
    addService(service) {
      console.log("testt service", service)
      console.log("testt this.model.services", this.model.services)
      this.model.services.push(service)
    },
    async getEmployees() {
      if (this.employees.length === 0) {
        await this.$store.dispatch("fetchEmployees", {limit: 200}).then((data) => {
          console.log("fetchEmployees", data)
          this.employees = data.data
        })
      }
    },
    async getSettings(id) {
      const clientSettings = await this.$store.dispatch("fetchClient", id)
      console.log("clientSettings id", id)
      console.log("clientSettings", clientSettings)
      if (!clientSettings.hasOwnProperty("configs") || clientSettings.configs == null) {
        this.clientConfigs = await this.$store.dispatch("fetchSettings")
      } else {
        this.clientConfigs = clientSettings.configs
      }
      console.log("this.clientConfigs", this.clientConfigs)

      const client = await this.$store.dispatch("fetchClient", id)

      if (Object.hasOwn(client, "address")) {
        this.model.address = client["address"]
      }
    },
    async getClients() {
      await this.$store.dispatch("fetchClients").then((data) => {
        // console.log("fetchClients", data)
        this.clients = data
      })
    },
    async getServices(serviceType, employeeType) {
      if (serviceType == null || employeeType == null) {
        return
      }

      this.services = []
      this.services = await this.$store.dispatch("fetchAllServices", {type: serviceType, employeeType: employeeType})
      console.log("servicessssss", this.services)


      if (this.servicesFromCache.length === 0) {
        console.log("servicessssss not clearing")
        this.model.services = []

        if (this.services.length === 1 && this.model.services.length === 0) {
          this.addService(this.services[0])
        }
      } else {
        const cachedServices = this.servicesFromCache.slice()
        this.servicesFromCache = []
        this.model.services = []
        cachedServices.forEach( s => {
          const serv = this.services.find( p => p.id === s.id)
          console.log("serv:" + s.id, serv)
          if (serv) {
            this.addService(serv)
          }
        })
      }
    },
    async getRequest() {
      const data = await this.$store.dispatch("fetchRequest", this.$route.params.id)

      let selectedPositions = []
      data.forEach(positionsId => {
        let selected = this.positions.find(pos => pos.key === positionsId)
        if (selected) {
          selectedPositions.push(selected)
        }
      })

      this.model = data
      this.model.positionIds = selectedPositions
    },
    async submit() {
      let self = this

      this.v$.$touch()

      if (this.v$.model.$invalid) {
        console.log(this.v$.$errors.map( err => { return err.$message })[0])

        this.errorMessage = this.$t("Please fill in all required fields")
        this.loadingProcess = "failed"
        return
      }

      let request = JSON.parse(JSON.stringify(this.model))
      let payload = {
        clientId: request.clientId.id,
        employeeType: request.employeeType,
        serviceType: request.serviceType,
        notes: this.model.notes,
        cost: request.cost,
        gender: request.gender,
        address: request.address,
        preferredPaymentMethod: request.preferredPaymentMethod
      }

      if (request.serviceType === "shift") {

        payload["services"] = [{
          id: request.shiftService.id,
          priceInCents: request.shiftService.priceInCents,
          timeSlot: request.shiftSlot
        }]

        const startTime = request.shiftSlot.startTime.split(":")
        const endTime = request.shiftSlot.endTime.split(":")
        console.log("startTime", endTime)
        console.log("request.shiftDate ", request.shiftDate)
        payload["startDate"] = this.$moment(request.shiftDate).set({
          hour: startTime[0],
          minute: startTime[1],
          second: 0
        }).toDate()

        let startDate = this.$moment(request.shiftDate).set({hour: endTime[0], minute: endTime[1], second: 0})
        if (startTime[0] > endTime[0]) {
          startDate = startDate.add(1, "day")
        }
        payload["endDate"] = startDate.toDate()
      } else {
        var startDate = this.$moment(request.shiftDate).set({hour: 0, minute: 0, second: 0})
        if (request.startTime) {
          const startTime = this.$moment(request.startTime)
          console.log("startTime hours", startTime.hours())
          console.log("startTime minutes", startTime.minutes())
          startDate = startDate.set({hour: startTime.hours(), minute: startTime.minutes(), second: 0}).toDate()
        } else {
          console.log("startDate", startDate)
          startDate = startDate.toDate()
        }

        var endDate = this.$moment(request.shiftDate)
        if (request.endTime) {
          const endTime = this.$moment(request.endTime)
          endDate = endDate.set({hour: endTime.hours(), minute: endTime.minutes(), second: 0}).toDate()
        } else {
          endDate = endDate.set({hour: 23, minute: 59, second: 59})
          endDate = endDate.toDate()
        }


        payload["startDate"] = startDate
        payload["endDate"] = endDate

        payload["services"] = request.services.map((service) => {
          return {
            id: service.id,
            priceInCents: service.priceInCents,
          }
        })
      }

      console.log("payload", payload)

      this.loadingProcess = "processing"
      FirebaseFunctionsHelper.callFunction(
          "request-create",
          // eslint-disable-next-line no-undef
          payload
      )
          .then((result) => {
            console.log("res", result)
            // eslint-disable-next-line no-prototype-builtins
            if (result != null && result.hasOwnProperty("message")) {
              console.log("result message", result.message)
              self.loadingProcess = "failed"
              self.errorMessage = result.message
              return
            }
            console.log("submitUser result", result)
            this.loadingProcess = "done"

            this.$router.push({path: "/requests/" + result})
            this.$swal.fire({
              icon: "success",
              html: this.$t("Please wait for confirmation of acceptance of your request from a healthcare professional."),
              title: this.$t("Your request has been successfully submitted!"),
              showConfirmButton: true,
              confirmButtonColor: "green"
            })

          })
          .catch((error) => {
            self.loadingProcess = "failed"
            self.errorMessage = error.message
            console.log("submitUser error", error)
          })

      // setTimeout(() => {
      //   this.loadingProcess = "failed";
      //   this.loadingMessage = "There was an error.";
      //   //Add Tokens
      // }, 2000);
    },
    clearForm() {
      this.loadingProcess = ""
      this.model = {
          // requestStatus: {id: "PENDING", name: this.$t("Pending")},
          clientId: null,
          preferredPaymentMethod: null,
          serviceType: null,
          buyerId: null,
          shiftDate: null,
          notes: null,
          endTime: null,
          employeeType: null,
          startTime: null,
          // shiftService: {name: {en:"",gr:""}, timeSlots: []},
          shiftService: null,
          shiftSlot: null,
          gender: "noPref",
          services: [],
          address: {
            street: "",
            city: "",
            postCode: "",
            locality: "",
            countryCode: "CY",
          },
          cost: {
            totalCost: null,
            employeeEarnings: null,
            companyCommission: null,
          }
        }

    },
  },
}
</script>

<style scoped>
.progress-bar {
  transition: width 0.4s ease
}
</style>
